"use client";

import { formatPriceWithFallback } from "@/features/games/details/utils/price";

interface SearchGamePriceProps {
  isFree?: boolean | null;
  priceDiscount?: number | null;
  priceInitialFormatted?: string | null;
  priceFinalFormatted?: string | null;
  priceFinal?: number | null;
}

export function SearchGamePrice({
  isFree,
  priceDiscount,
  priceInitialFormatted,
  priceFinalFormatted,
  priceFinal,
}: SearchGamePriceProps) {
  if (isFree) {
    return (
      <span className="text-[#beee11] font-semibold text-xs">Free</span>
    );
  }

  if (priceDiscount && priceDiscount > 0) {
    return (
      <>
        <span className="bg-[#4c6b22] text-[#a4d007] px-1 py-0.5 rounded text-[10px] sm:text-xs font-bold">
          -{priceDiscount}%
        </span>
        {priceInitialFormatted && (
          <span className="line-through text-[#8f98a0] text-[10px] sm:text-xs">
            {priceInitialFormatted}
          </span>
        )}
        <span className="text-[#beee11] font-semibold text-[10px] sm:text-xs">
          {formatPriceWithFallback(priceFinalFormatted, priceFinal, "")}
        </span>
      </>
    );
  }

  if (priceFinal !== null && priceFinal !== undefined) {
    return (
      <span className="text-white text-xs">
        {formatPriceWithFallback(priceFinalFormatted, priceFinal, "")}
      </span>
    );
  }

  return null;
}
